import React, { Component } from 'react';

class User extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };

    }

    componentDidMount() {
    }

    render() {
        return (
            <div id="user">
                User
            </div>
        )

    }
}

export default User;



// WEBPACK FOOTER //
// ./src/route/User.js